import * as Toolkit from '../../../toolkit/index';
import * as UIToolkit from '../../../UIToolkit/index';
import * as Utils from '../../../utils/util';
import * as FrontCubeData from '../../../frontCubeData/index';

// 渲染货架底部, 如果高度为0，则隐藏dom
export function setShelfFooterStyle(cube: CubeNode): void {
    let width: number = UIToolkit.getPXSizeValue(cube.id, 'width');
    let footerHeight: number = UIToolkit.getPXSizeValue(cube.id, 'legHeight');

    if (footerHeight === 0) {
        cube.jView.find('.J_ElementBoxFooterSlot').css({
            width: '',
            height: ''
        });
    }
    else {
        cube.jView.find('.J_ElementBoxFooterSlot').css({
            width: `${width}px`,
            height: `${footerHeight}px`
        });
    }
}
